import { createAction, props } from '@ngrx/store';
import { MessageResponse } from '../../../models/message-response.model';

export const loadMessages = createAction('[Messages] Load Messages');

export const loadSupportChatsSuccess = createAction(
  '[SupportChat] Load SupportChats Success',
  props<{ data: any }>()
);
export const loadMessagesSuccess = createAction(
  '[Messages] Load Messages Success',
  props<{ messages: MessageResponse[] | null }>()
);

export const setMessageDetails = createAction(
  '[Messages details] Messages details  Component',
  props<{ messageDetails: any }>()
);

export const updateMessageDetails = createAction(
  '[Messages details] Messages details - Mark Read',
  props<{ read: boolean }>()
);

export const resetMessageDetails = createAction(
  '[Reset  Messages details] Reset Details'
);

export const confirmSupportChatForm = createAction(
  '[SupportChat New Message ] Load New Message Success',
  props<{ confirmSupportChatForm: any }>()
);

export const loadSupportChatsFailure = createAction(
  '[SupportChat] Load SupportChats Failure',
  props<{ error: any }>()
);
export const loadMessagesFailure = createAction(
  '[Messages] Load Messages Failure',
  props<{ error: any }>()
);

// API actions
export const loadMessagesAPI = createAction('[Messages] Load Messages API');
